export default __webpack_public_path__ + "static/media/stairs.3a3cd9bf.svg";